<template>
    <v-container fluid>
        <h1 class="text-center bot-color-blue">Quản lý dự án SEO</h1>
        <div class="text-center mt-2">
            <v-btn color="primary" @click="addProject">
                Thêm dự án
                <v-icon right> mdi-plus-circle </v-icon>
            </v-btn>
        </div>
        <v-row>
            <v-col v-for="(prj, p) in projectList" :key="p" :class="projectList.length === 1 ? 'bot-center' : ''"
                cols="12" xs="12" sm="6" md="4" lg="3" xl="3">
                <v-card>
                    <v-card-title>
                        {{ `${prj.No}. ${prj.ProjectTitle}` }}
                    </v-card-title>

                    <v-card-text>
                        <table class="bot-table">
                            <tbody>
                                <tr>
                                    <th>Host:</th>
                                    <td>{{ prj.ProjectHost }}</td>
                                </tr>
                                <tr>
                                    <th>Từ khóa:</th>
                                    <td>
                                        <a :href="prj.LinkRanking">Chi tiết</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text :href="`/project/detail/${prj.ProjectID}`">
                            Chi tiết
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <project-item v-model="selectedItem" />
    </v-container>
</template>

<script>
import ProjectItem from "./project.item.vue";
export default {
    name: "project-list",

    components: {
        "project-item": ProjectItem,
    },

    // this is state
    data() {
        return {
            hlog: this.$options.filters.hlog,
            selectedItem: {
                showDialog: false,
            },
        };
    },

    async asyncData({ store }) {
        const dp = store.dispatch;
        await dp("views/projects/loadList");
    },

    computed: {
        ua() {
            return this.$store.state.useragent;
        },
        projectList() {
            let { projects } = this.$store.state.views;
            let list = [];
            for (let [p, prj] of projects.list.entries()) {
                let obj01 = {
                    No: p + 1,
                    LinkRanking: `/link/ranking/${prj.ProjectID}`,
                };
                let obj02 = prj;
                let obj = Object.assign(obj01, obj02);
                list.push(obj);
            }
            return list;
        },
    },

    methods: {
        editProject(prj) {
            this.hlog.start("project", "edit", prj);
            let obj01 = { showDialog: true, action: "update" };
            let obj02 = prj;
            this.selectedItem = Object.assign(obj01, obj02);
        },
        addProject() {
            let prj = { showDialog: true, action: "add" };
            this.hlog.start("project", "add", prj);
            this.selectedItem = { showDialog: true, action: "add" };
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
::v-deep .bot-table {
    border: none;
    box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// project.list.vue